import { Avatar, Stack, styled, Typography } from '@mui/material'
import { closeCurrentModal } from 'weblite-web-modal-viewer'
import { SecondaryButton } from '$common/buttons'
import { BottomDrawer } from '$common/bottom-drawer'
import {
  getUserAvatarText,
  getUserDisplayName,
  getUserFirstName,
  useUser,
} from '$logic/users'
import { toHumanReadablePhone } from '$func/phone'
import { getOpenedRoomId } from '$logic/opened-room'
import { sendContactMessage } from '$logic/message'
import { closeShareContactList } from '$logic/router'
import { getUserImageUrl } from '$func/imageUrl'
import { t } from '$i18n'
import { AvatarBase } from '$common/avatar/avatar-base'
import { stringToColor } from '$func/string-to-color'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const Root = styled(Stack)`
  width: 100%;
  height: 100%;
  align-items: center;
  overflow: hidden;
  padding: 24px 16px 16px 16px;
`

const TitleTypography = styled(Typography)`
  width: 100%;
  text-align: center;
`

interface Props {
  userId: string
  isOpen?: boolean
}

export function ShareContactDialog({ userId, isOpen = false }: Props) {
  const { user, loading } = useUser(userId)
  const name = getUserDisplayName(user)
  const onShare = async () => {
    if (!user) return
    const roomId = getOpenedRoomId()
    sendContactMessage(roomId, userId).then(() =>
      setTimeout(async () => {
        await closeCurrentModal()
        closeShareContactList()
      }, 0),
    )
  }

  const avatarBackgroundColor = stringToColor(getUserFirstName(user), user?.id)

  return (
    <BottomDrawer isOpen={isOpen} onClose={closeCurrentModal}>
      <Root>
        <AvatarBase
          src={getUserImageUrl(user)}
          size={AvatarSize._3XL}
          sx={{ marginBottom: '16px' }}
          backgroundColor={avatarBackgroundColor}
        >
          {getUserAvatarText(user)}
        </AvatarBase>

        <TitleTypography variant="subtitle1" noWrap marginBottom="4px">
          {name}
        </TitleTypography>

        <Typography color="gray" variant="body2" marginBottom="24px">
          {user ? toHumanReadablePhone(user.phone) : null}
        </Typography>

        <SecondaryButton
          text={t('shareContact.share')}
          onClick={onShare}
          disabled={loading}
          sx={{ width: '100%' }}
        />
      </Root>
    </BottomDrawer>
  )
}
